export const handleRangeSave = ({
    setIsRangeModal,
    currentDevice,
    setChangeRange,
    changeRange,
    setStartPoint,
    startPoint,
    setEndPoint,
    endPoint,
    setSpecificMaxVal,
    setSpecificMinVal,
    tempImages,
    selectedDevice,
    tempTabIndexGauge,
    activeTabIndex,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    setTempTabIndexGauge,
    setUpdatedTabIndexGauge,
    multipleGauge,
    setMultipleGauge,
    setUpdatedMultipleGauge,
    setMaximumVal,
    maximumVal,
    setMinimumVal,
    minimumVal,
    multipleProgress,
    tabIndexProgress,
    tempTabIndexProgress,
    setImages,
    setMultipleProgress,
    setUpdatedMultipleProgress,
    setTempTabIndexProgress,
    setUpdatedTabIndexProgress,
    multipleCircularProgress,
    tabIndexCircularProgress,
    tempTabIndexCircularProgress,
    setTempTabIndexCircularProgress,
    setUpdatedTabIndexCircularProgress,
    setMultipleCircularProgress,
    setUpdatedMultipleCircularProgress,
    updatedMultipleCircularProgress,
    updatedMultipleProgress,
    updatedMultipleGauge,
    multipleSlider,
    tabIndexSlider,
    tempTabIndexSlider,
    setTempTabIndexSlider,
    setUpdatedTabIndexSlider,
    updatedMultipleSlider,
    setMultipleSlider,
    setUpdatedMultipleSlider,


}) => {
    setIsRangeModal(false);
    if (currentDevice === "Gauge") {
        setChangeRange(!changeRange);
        const minValue = document.getElementById("minValue").value;
        const maxValue = document.getElementById("maxValue").value;
        setStartPoint(startPoint.concat(minValue));
        setEndPoint(endPoint.concat(maxValue));
        setSpecificMaxVal(maxValue);
        setSpecificMinVal(minValue);
        const originalDeviceIndex = tempImages.findIndex(
            (data) => data.id === selectedDevice.id
        );

        if (Object.keys(tempTabIndexGauge).length > 0) {
            const particularDevice = tempTabIndexGauge[activeTabIndex];
            if (particularDevice !== undefined) {
                if (selectedDevice?.id) {

                    if (
                        tempTabIndexGauge[activeTabIndex].some(
                            (device) => device.id === selectedDevice.id
                        )
                    ) {
                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            const previousMinVal =
                                temporaryWidgets[originalDeviceIndex].minval;
                            const previousMaxValue =
                                temporaryWidgets[originalDeviceIndex].maxVal;
                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                minVal: minValue !== null ? minValue : previousMinVal,
                                maxVal: maxValue !== null ? maxValue : previousMaxValue,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);

                            let oldtabIndexGauge = [...tempTabIndexGauge[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexGauge.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            if (organizedDeviceIndex !== -1) {
                                // Ensure the index is found
                                const updatedDevice = {
                                    ...oldtabIndexGauge[organizedDeviceIndex],
                                    minVal: minValue !== null ? minValue : previousMinVal,
                                    maxVal: maxValue !== null ? maxValue : previousMaxValue,
                                };

                                oldtabIndexGauge[organizedDeviceIndex] = updatedDevice;
                                const newTempTabIndexGauge = {
                                    [activeTabIndex]: oldtabIndexGauge,
                                };



                                setTempTabIndexGauge(newTempTabIndexGauge);
                                setUpdatedTabIndexGauge(newTempTabIndexGauge);
                            }
                        }
                    }
                }
            }
        }

        if (multipleGauge.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = updatedMultipleGauge;
                const deviceToUpdate = updatedMultipleGauge.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.minVal = minValue;
                deviceToUpdate.maxVal = maxValue;

                console.log("updatedDevice:", updatedDeviceName);
                setMultipleGauge(updatedDeviceName);
                setUpdatedMultipleGauge(updatedDeviceName);
            }
        }

    }


    if (currentDevice === "ProgressBar") {
        const minValue = document.getElementById("minValue").value;
        const maxValue = document.getElementById("maxValue").value;
        setMaximumVal(maximumVal.concat(maxValue));
        setMinimumVal(minimumVal.concat(minValue));
        if (multipleProgress.length <= 1) {
            if (selectedDevice?.id) {
                if (
                    tabIndexProgress[activeTabIndex].some(
                        (device) => device.id === selectedDevice.id
                    )
                ) {
                    const particularDevice = tempTabIndexProgress[activeTabIndex];
                    const originalDeviceIndex = tempImages.findIndex(
                        (data) => data.id === selectedDevice.id
                    );
                    if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
                        // storing new channel name to send data in widget
                        let temporaryWidgets = tempImages;
                        const previousMinValue =
                            temporaryWidgets[originalDeviceIndex].minVal;
                        const previousMaxValue =
                            temporaryWidgets[originalDeviceIndex].maxVal;

                        temporaryWidgets[originalDeviceIndex].minVal =
                            minValue !== null ? minValue : previousMinValue;
                        temporaryWidgets[originalDeviceIndex].maxVal =
                            maxValue !== null ? maxValue : previousMaxValue;
                        setTempImages(temporaryWidgets);
                        setUpdatedImages(temporaryWidgets);
                        setImages(temporaryWidgets);

                        // storing new channel name to display data in main page

                        let oldtabIndexProgressBar = tempTabIndexProgress[activeTabIndex];
                        const organizedDeviceIndex = oldtabIndexProgressBar.findIndex(
                            (data) => data.id === selectedDevice.id
                        );
                        if (organizedDeviceIndex !== -1) {
                            // Ensure the index is found
                            const updatedDevice = {
                                ...oldtabIndexProgressBar[organizedDeviceIndex],
                                minVal: minValue !== null ? minValue : previousMinValue,
                                maxVal: maxValue !== null ? maxValue : previousMaxValue,
                            };


                            oldtabIndexProgressBar[organizedDeviceIndex] = updatedDevice;
                            const newTempTabIndexGauge = {
                                [activeTabIndex]: oldtabIndexProgressBar,
                            };

                            setTempTabIndexProgress(newTempTabIndexGauge);
                            setUpdatedTabIndexProgress(newTempTabIndexGauge);
                        }
                    }
                }
            }
        }


        if (multipleProgress.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleProgress;
                const deviceToUpdate = multipleProgress.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.minVal = minValue;
                deviceToUpdate.maxVal = maxValue;
                setMultipleProgress(updatedDeviceName);
                setUpdatedMultipleProgress(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "CircularProgress") {
        const maxValue = document.getElementById("maxValue").value;
        setMaximumVal(maximumVal.concat(maxValue));
        if (multipleCircularProgress.length <= 1) {
            if (selectedDevice?.id) {
                if (
                    tabIndexCircularProgress[activeTabIndex].some(
                        (device) => device.id === selectedDevice.id
                    )
                ) {
                    const particularDevice = tempTabIndexCircularProgress[activeTabIndex];
                    const originalDeviceIndex = tempImages.findIndex(
                        (data) => data.id === selectedDevice.id
                    );
                    if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
                        // storing new channel name to send data in widget
                        let temporaryWidgets = tempImages;

                        const previousMaxValue =
                            temporaryWidgets[originalDeviceIndex].maxVal;


                        temporaryWidgets[originalDeviceIndex].maxVal =
                            maxValue !== null ? maxValue : previousMaxValue;

                        setTempImages(temporaryWidgets);
                        setUpdatedImages(temporaryWidgets);
                        setImages(temporaryWidgets);

                        // storing new channel name to display data in main page

                        let oldtabIndexCircularProgressBar = tempTabIndexCircularProgress[activeTabIndex];
                        const organizedDeviceIndex = oldtabIndexCircularProgressBar.findIndex(
                            (data) => data.id === selectedDevice.id
                        );

                        if (organizedDeviceIndex !== -1) {
                            // Ensure the index is found
                            const updatedDevice = {
                                ...oldtabIndexCircularProgressBar[organizedDeviceIndex],
                                maxVal: maxValue !== null ? maxValue : previousMaxValue,
                            };


                            oldtabIndexCircularProgressBar[organizedDeviceIndex] = updatedDevice;
                            const newTempTabIndexGauge = {
                                [activeTabIndex]: oldtabIndexCircularProgressBar,
                            };

                            setTempTabIndexCircularProgress(newTempTabIndexGauge);
                            setUpdatedTabIndexCircularProgress(newTempTabIndexGauge);
                        }
                    }
                }
            }
        }

        if (multipleCircularProgress.length > 1) {

            if (!selectedDevice?.id) {
                const updatedDeviceName = updatedMultipleCircularProgress;
                const deviceToUpdate = updatedMultipleCircularProgress.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.maxVal = maxValue;
                setMultipleCircularProgress(updatedDeviceName);
                setUpdatedMultipleCircularProgress(updatedDeviceName);
            }
        }
    }



    if (currentDevice === "Slider") {
        const minValue = document.getElementById("minValue").value;
        const maxValue = document.getElementById("maxValue").value;
        setMaximumVal(maximumVal.concat(maxValue));
        setMinimumVal(minimumVal.concat(minValue));
        if (multipleSlider.length <= 1) {
            if (selectedDevice?.id) {
                if (
                    tabIndexSlider[activeTabIndex].some(
                        (device) => device.id === selectedDevice.id
                    )
                ) {
                    const particularDevice = tempTabIndexSlider[activeTabIndex];
                    const originalDeviceIndex = tempImages.findIndex(
                        (data) => data.id === selectedDevice.id
                    );
                    if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
                        // storing new channel name to send data in widget
                        let temporaryWidgets = tempImages;
                        const previousMinValue =
                            temporaryWidgets[originalDeviceIndex].minVal;
                        const previousMaxValue =
                            temporaryWidgets[originalDeviceIndex].maxVal;

                        temporaryWidgets[originalDeviceIndex].minVal =
                            minValue !== null ? minValue : previousMinValue;
                        temporaryWidgets[originalDeviceIndex].maxVal =
                            maxValue !== null ? maxValue : previousMaxValue;
                        setTempImages(temporaryWidgets);
                        setUpdatedImages(temporaryWidgets);
                        setImages(temporaryWidgets);

                        // storing new channel name to display data in main page

                        let oldtabIndexSlider = tempTabIndexSlider[activeTabIndex];
                        const organizedDeviceIndex = oldtabIndexSlider.findIndex(
                            (data) => data.id === selectedDevice.id
                        );
                        if (organizedDeviceIndex !== -1) {
                            // Ensure the index is found
                            const updatedDevice = {
                                ...oldtabIndexSlider[organizedDeviceIndex],
                                minVal: minValue !== null ? minValue : previousMinValue,
                                maxVal: maxValue !== null ? maxValue : previousMaxValue,
                            };


                            oldtabIndexSlider[organizedDeviceIndex] = updatedDevice;
                            const newTempTabIndexGauge = {
                                [activeTabIndex]: oldtabIndexSlider,
                            };

                            setTempTabIndexSlider(newTempTabIndexGauge);
                            setUpdatedTabIndexSlider(newTempTabIndexGauge);
                        }
                    }
                }
            }
        }

        if (multipleSlider.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = updatedMultipleSlider;
                const deviceToUpdate = updatedMultipleSlider.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.minVal = minValue;
                deviceToUpdate.maxVal = maxValue;
                setMultipleSlider(updatedDeviceName);
                setUpdatedMultipleSlider(updatedDeviceName);
            }
        }
    }
};

export const handleRotateBar = ({
    setRotateBar,
    rotateBar,
    tempTabIndexProgress,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    setImages,
    setTempTabIndexProgress,
    setUpdatedTabIndexProgress
}) => {
    setRotateBar(!rotateBar);

    if (Object.keys(tempTabIndexProgress).length > 0) {
        const particularDevice = tempTabIndexProgress[activeTabIndex];
        if (particularDevice !== undefined) {
            const originalDeviceIndex = tempImages.findIndex(
                (data) => data.id === selectedDevice.id
            );
            if (
                tempTabIndexProgress[activeTabIndex].some(
                    (device) => device.id === selectedDevice.id
                )
            ) {
                if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];

                    const previousRotate = temporaryWidgets[originalDeviceIndex].rotate;

                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        rotate: !previousRotate,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);
                    setImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexProgressBar = [
                        ...tempTabIndexProgress[activeTabIndex],
                    ];

                    const organizedDeviceIndex = oldtabIndexProgressBar.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexProgressBar[organizedDeviceIndex],
                        rotate: !previousRotate,
                    };

                    oldtabIndexProgressBar[organizedDeviceIndex] = newUpdatedData;
                    const newTempTabIndexProgress = {
                        [activeTabIndex]: oldtabIndexProgressBar,
                    };

                    setTempTabIndexProgress(newTempTabIndexProgress);
                    setUpdatedTabIndexProgress(newTempTabIndexProgress);
                }
            }
        }
    }
};


export const handleSaveCheckBox = ({
    setIsChannelCheckBox,
    currentDevice,
    tempTabIndexGrid,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    gridChannels,
    setTempImages,
    setUpdatedImages,
    setTempTabIndexGrid,
    setUpdatedTabIndexGrid,
    multipleGrid,
    setMultipleGrid,
    setGridChannels
}) => {
    setIsChannelCheckBox(false);
    if (currentDevice === "Grid") {
        if (Object.keys(tempTabIndexGrid).length > 0) {
            const particularDevice = tempTabIndexGrid[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (selectedDevice?.id) {

                    if (tempTabIndexGrid[activeTabIndex].some((device) => device.id === selectedDevice.id)) {

                        if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                            let temporaryWidgets = [...tempImages];
                            temporaryWidgets[originalDeviceIndex].chartChannel = gridChannels;

                            const updatedData = {
                                ...temporaryWidgets[originalDeviceIndex],
                                chartChannel: gridChannels,
                            };
                            temporaryWidgets[originalDeviceIndex] = updatedData;
                            setTempImages(temporaryWidgets);
                            setUpdatedImages(temporaryWidgets);

                            // storing new channel name to display data in main page
                            let oldtabIndexGrid = [...tempTabIndexGrid[activeTabIndex]];
                            const organizedDeviceIndex = oldtabIndexGrid.findIndex(
                                (data) => data.id === selectedDevice.id
                            );

                            const newUpdatedData = {
                                ...oldtabIndexGrid[organizedDeviceIndex],
                                chartChannel: gridChannels,
                            };

                            oldtabIndexGrid[organizedDeviceIndex] = newUpdatedData;
                            const newTempTabIndexDevices = {
                                [activeTabIndex]: oldtabIndexGrid,
                            };

                            setTempTabIndexGrid(newTempTabIndexDevices);
                            setUpdatedTabIndexGrid(newTempTabIndexDevices);
                        }
                    }
                }
            }
        }

        if (multipleGrid.length > 1) {
            if (!selectedDevice.id) {
                const updatedDeviceName = multipleGrid;
                const deviceToUpdate = multipleGrid.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.chartChannel = gridChannels;
                setMultipleGrid(updatedDeviceName);
            }
        }
    }
    setGridChannels([]);
};


export const handleSaveTimePeriod = ({
    setIsTimePeriod,
    currentDevice,
    multipleLineCharts,
    tempTabIndexLineChart,
    activeTabIndex,
    selectedDevice,
    clickedDeviceIndex,
    tempImages,
    endHours,
    endMinutes,
    setTempImages,
    setUpdatedImages,
    setTempTabIndexLineChart,
    setUpdatedTabIndexLineChart,
    setMultipleLineCharts,
    multipleHistogram,
    tempTabIndexHistogram,
    setTempTabIndexHistogram,
    setUpdatedTabIndexHistogram,
    setMultipleHistogram,

}) => {
    setIsTimePeriod(false);

    if (currentDevice === "LineChart") {
        if (multipleLineCharts.length <= 1) {
            const particularDevice = [...tempTabIndexLineChart[activeTabIndex]];
            if (selectedDevice?.id) {

                if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
                    const tempData = [...tempImages];

                    const originalDeviceIndex = tempImages.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const updatedData = {
                        ...tempData[originalDeviceIndex],
                        hour: endHours,
                        minute: endMinutes,
                    };

                    tempData[originalDeviceIndex] = updatedData;
                    setTempImages(tempData);
                    setUpdatedImages(tempData);
                    // setImages(tempData);

                    const organizedDeviceIndex = particularDevice.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...particularDevice[organizedDeviceIndex],
                        hour: endHours,
                        minute: endMinutes,
                    };

                    particularDevice[organizedDeviceIndex] = newUpdatedData;
                    const newDeviceData = {
                        [activeTabIndex]: particularDevice,
                    };

                    setTempTabIndexLineChart(newDeviceData);
                    setUpdatedTabIndexLineChart(newDeviceData);
                }
            }
        }

        if (multipleLineCharts.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleLineCharts;
                const deviceToUpdate = multipleLineCharts.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.hour = endHours;
                deviceToUpdate.minute = endMinutes;
                setMultipleLineCharts(updatedDeviceName);
            }
        }
    }

    if (currentDevice === "Histogram") {
        if (multipleHistogram.length <= 1) {
            const particularDevice = [...tempTabIndexHistogram[activeTabIndex]];
            if (selectedDevice?.id) {

                if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
                    const tempData = [...tempImages];

                    const originalDeviceIndex = tempImages.findIndex(
                        (data) => data.id === selectedDevice.id
                    );
                    const updatedData = {
                        ...tempData[originalDeviceIndex],
                        hour: endHours,
                        minute: endMinutes,
                    };

                    tempData[originalDeviceIndex] = updatedData;
                    setTempImages(tempData);
                    setUpdatedImages(tempData);

                    const organizedDeviceIndex = particularDevice.findIndex(
                        (data) => data.id === selectedDevice.id
                    );
                    const newUpdatedData = {
                        ...particularDevice[organizedDeviceIndex],
                        hour: endHours,
                        minute: endMinutes,
                    };

                    particularDevice[organizedDeviceIndex] = newUpdatedData;
                    const newDeviceData = {
                        [activeTabIndex]: particularDevice,
                    };

                    setTempTabIndexHistogram(newDeviceData);
                    setUpdatedTabIndexHistogram(newDeviceData);
                }
            }
        }

        if (multipleHistogram.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = multipleHistogram;
                const deviceToUpdate = multipleHistogram.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.hour = endHours;
                deviceToUpdate.minute = endMinutes;
                setMultipleHistogram(updatedDeviceName);
            }
        }
    }
};


export const handleChangeFormat = ({
    setTableFormat,
    tableFormat,
    tempTabIndexTable,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    setTempTabIndexTable,
    setUpdatedTabIndexTable,
    multipleTable,
    setMultipleTable
}) => {
    setTableFormat(!tableFormat);
    if (Object.keys(tempTabIndexTable).length > 0) {
        const particularDevice = tempTabIndexTable[activeTabIndex];
        if (particularDevice !== undefined) {
            const originalDeviceIndex = tempImages.findIndex(
                (data) => data.id === selectedDevice.id
            );
            if (selectedDevice?.id) {

                if (particularDevice[clickedDeviceIndex].id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];
                    const previousFormat = temporaryWidgets[originalDeviceIndex].column;

                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        column: !previousFormat,
                    };
                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);
                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexTable[activeTabIndex]];
                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );
                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        column: !previousFormat,
                    };
                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;
                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };
                    setTempTabIndexTable(newTempTabIndexDevices);
                    setUpdatedTabIndexTable(newTempTabIndexDevices);
                }
            }
        }
    }

    if (multipleTable.length > 1) {
        if (!selectedDevice?.id) {
            const updatedDeviceName = multipleTable;
            updatedDeviceName[clickedDeviceIndex].column = !tableFormat;
            setMultipleTable(updatedDeviceName);
        }
    }
};


export const handleChangeBg = ({
    currentDevice,
    tempTabIndexDisplay,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    bgColor,
    textColor,
    fontSize,
    setTempImages,
    setUpdatedImages,
    setTempTabIndexDisplay,
    setUpdatedTabIndexDisplay,
    multipleDisplay,
    setMultipleDisplay,
    tempTabIndexText,
    textBgColor,
    widgetTextColor,
    textFontSize,
    addedText,
    textAlignVertically,
    textAlignHorizontally,
    setTempTabIndexText,
    setUpdatedTabIndexText,
    multipleText,
    setMultipleText,
    setIsBgColor,
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    multipleSquare,
    setMultipleSquare,
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,
    tempTabIndexPolygone,
    setTempTabIndexPolygone,
    setUpdatedTabIndexPolygone,
    multiplePolygone,
    setMultiplePolygone,
    setMultipleLink,
    multipleLink,
    setUpdatedTabIndexLink,
    setTempTabIndexLink,
    tempTabIndexLink,
    setMultipleClock,
    multipleClock,
    setTempTabIndexClock,
    setUpdatedTabIndexClock,
    tempTabIndexClock,
    setMultipleIO,
    multipleIO,
    setTempTabIndexIO,
    setUpdatedTabIndexIO,
    tempTabIndexIO,
    setMultiplePipe,
    multiplePipe,
    setTempTabIndexPipe,
    setUpdatedTabIndexPipe,
    tempTabIndexPipe,

    multipleGauge,
    setMultipleGauge,
    tempTabIndexGauge,
    setTempTabIndexGauge,
    setUpdatedTabIndexGauge,

    multipleProgress,
    setMultipleProgress,
    tempTabIndexProgress,
    setTempTabIndexProgress,
    setUpdatedTabIndexProgress,

    multipleLines,
    setMultipleLines,
    tempTabIndexLines,
    setTempTabIndexLines,
    setUpdatedTabIndexLines,

    multipleSwitch,
    setMultipleSwitch,
    tempTabIndexSwitch,
    setTempTabIndexSwitch,
    setUpdatedTabIndexSwitch,

    multipleSlider,
    setMultipleSlider,
    tempTabIndexSlider,
    setTempTabIndexSlider,
    setUpdatedTabIndexSlider,

    isTransparent,

    borderRadius,


}) => {

    // Applying bgColor, textColor and font to display

    if (currentDevice === "Display") {
        if (Object.keys(tempTabIndexDisplay).length > 0) {
            const particularDevice = tempTabIndexDisplay[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: bgColor,
                        textColor: textColor,
                        fontSize: fontSize
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexDisplay[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: bgColor,
                        textColor: textColor,
                        fontSize: fontSize
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };

                    setTempTabIndexDisplay(newTempTabIndexDevices);
                    setUpdatedTabIndexDisplay(newTempTabIndexDevices);
                }
            }
        }

        if (multipleDisplay.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleDisplay];
                const deviceToUpdate = multipleDisplay.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = bgColor;
                deviceToUpdate.fontSize = fontSize;
                deviceToUpdate.textColor = textColor;
                setMultipleDisplay(updatedDeviceName);
            }
        }

    }

    // Applying bgColor, textColor and font to text widget
    if (currentDevice === "Text") {

        if (Object.keys(tempTabIndexText).length > 0) {
            const particularDevice = tempTabIndexText[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (selectedDevice?.id) {

                    if (particularDevice[clickedDeviceIndex]?.id === selectedDevice?.id) {

                        // storing new channel name to send data in widget
                        let temporaryWidgets = [...tempImages];

                        const updatedData = {
                            ...temporaryWidgets[originalDeviceIndex],
                            bgColor: textBgColor,
                            textColor: widgetTextColor,
                            fontSize: textFontSize,
                            text: addedText,
                            alignVertically: textAlignVertically,
                            alignHorizontally: textAlignHorizontally,
                            isTransparent
                        };

                        temporaryWidgets[originalDeviceIndex] = updatedData;

                        setTempImages(temporaryWidgets);
                        setUpdatedImages(temporaryWidgets);

                        // storing new channel name to display data in main page

                        let oldtabIndexTable = [...tempTabIndexText[activeTabIndex]];

                        const organizedDeviceIndex = oldtabIndexTable.findIndex(
                            (data) => data.id === selectedDevice.id
                        );

                        const newUpdatedData = {
                            ...oldtabIndexTable[organizedDeviceIndex],
                            bgColor: textBgColor,
                            textColor: widgetTextColor,
                            fontSize: textFontSize,
                            text: addedText,
                            alignVertically: textAlignVertically,
                            alignHorizontally: textAlignHorizontally,
                            isTransparent
                        };

                        oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                        const newTempTabIndexDevices = {
                            [activeTabIndex]: oldtabIndexTable,
                        };

                        setTempTabIndexText(newTempTabIndexDevices);
                        setUpdatedTabIndexText(newTempTabIndexDevices);
                    }
                }
            }
        }

        if (multipleText.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleText];
                const deviceToUpdate = multipleText.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;
                deviceToUpdate.fontSize = textFontSize;
                deviceToUpdate.textColor = widgetTextColor;
                deviceToUpdate.text = addedText;
                deviceToUpdate.alignVertically = textAlignVertically;
                deviceToUpdate.alignHorizontally = textAlignHorizontally;
                deviceToUpdate.isTransparent = isTransparent;


                setMultipleText(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Link") {

        if (Object.keys(tempTabIndexLink).length > 0) {
            const particularDevice = tempTabIndexLink[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (selectedDevice?.id) {

                    if (particularDevice[clickedDeviceIndex]?.id === selectedDevice?.id) {

                        // storing new channel name to send data in widget
                        let temporaryWidgets = [...tempImages];

                        const updatedData = {
                            ...temporaryWidgets[originalDeviceIndex],
                            bgColor: textBgColor,
                            textColor: widgetTextColor,
                            fontSize: textFontSize,
                            text: addedText,
                            alignVertically: textAlignVertically,
                            alignHorizontally: textAlignHorizontally
                        };

                        temporaryWidgets[originalDeviceIndex] = updatedData;

                        setTempImages(temporaryWidgets);
                        setUpdatedImages(temporaryWidgets);

                        // storing new channel name to display data in main page

                        let oldtabIndexTable = [...tempTabIndexLink[activeTabIndex]];

                        const organizedDeviceIndex = oldtabIndexTable.findIndex(
                            (data) => data.id === selectedDevice.id
                        );

                        const newUpdatedData = {
                            ...oldtabIndexTable[organizedDeviceIndex],
                            bgColor: textBgColor,
                            textColor: widgetTextColor,
                            fontSize: textFontSize,
                            text: addedText,
                            alignVertically: textAlignVertically,
                            alignHorizontally: textAlignHorizontally
                        };

                        oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                        const newTempTabIndexDevices = {
                            [activeTabIndex]: oldtabIndexTable,
                        };

                        setTempTabIndexLink(newTempTabIndexDevices);
                        setUpdatedTabIndexLink(newTempTabIndexDevices);
                    }
                }
            }
        }

        if (multipleLink.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleLink];
                const deviceToUpdate = multipleLink.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;
                deviceToUpdate.fontSize = textFontSize;
                deviceToUpdate.textColor = widgetTextColor;
                deviceToUpdate.text = addedText;
                deviceToUpdate.alignVertically = textAlignVertically;
                deviceToUpdate.alignHorizontally = textAlignHorizontally;


                setMultipleLink(updatedDeviceName);
            }
        }

    }


    if (currentDevice === "Square") {
        if (Object.keys(tempTabIndexSquare).length > 0) {
            const particularDevice = tempTabIndexSquare[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: textBgColor,
                        text: addedText,
                        textColor: widgetTextColor,
                        fontSize: textFontSize,
                        borderRadius
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexSquare[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: textBgColor,
                        textColor: widgetTextColor,
                        text: addedText,
                        fontSize: textFontSize,
                        borderRadius

                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };




                    setTempTabIndexSquare(newTempTabIndexDevices);
                    setUpdatedTabIndexSquare(newTempTabIndexDevices);
                }
            }
        }
        if (multipleSquare.length > 1) {
            if (!selectedDevice?.id) {
                const updatedDeviceName = [...multipleSquare];
                const deviceToUpdate = multipleSquare.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;
                deviceToUpdate.text = addedText;
                deviceToUpdate.textColor = widgetTextColor;
                deviceToUpdate.fontSize = textFontSize;
                deviceToUpdate.borderRadius = borderRadius;


                setMultipleSquare(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Circle") {
        if (Object.keys(tempTabIndexCircle).length > 0) {
            const particularDevice = tempTabIndexCircle[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: textBgColor,
                        text: addedText,
                        textColor: widgetTextColor,
                        fontSize: textFontSize
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexCircle[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: textBgColor,
                        text: addedText,
                        textColor: widgetTextColor,
                        fontSize: textFontSize
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexCircle(newTempTabIndexDevices);
                    setUpdatedTabIndexCircle(newTempTabIndexDevices);
                }
            }
        }

        if (multipleCircle.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleCircle];
                const deviceToUpdate = multipleCircle.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;
                deviceToUpdate.text = addedText;
                deviceToUpdate.textColor = widgetTextColor;
                deviceToUpdate.fontSize = textFontSize;

                setMultipleCircle(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Polygone") {
        if (Object.keys(tempTabIndexPolygone).length > 0) {

            const particularDevice = tempTabIndexPolygone[activeTabIndex];

            if (particularDevice !== undefined) {

                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {

                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: textBgColor,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;
                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexPolygone[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: textBgColor
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };


                    setTempTabIndexPolygone(newTempTabIndexDevices);
                    setUpdatedTabIndexPolygone(newTempTabIndexDevices);
                }
            }
        }

        if (multiplePolygone.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multiplePolygone];
                const deviceToUpdate = multiplePolygone.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;

                setMultiplePolygone(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Pipe") {
        if (Object.keys(tempTabIndexPipe).length > 0) {

            const particularDevice = tempTabIndexPipe[activeTabIndex];

            if (particularDevice !== undefined) {

                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {

                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: textBgColor,
                        textColor: widgetTextColor
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;
                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexPipe[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: textBgColor,
                        textColor: widgetTextColor
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };


                    setTempTabIndexPipe(newTempTabIndexDevices);
                    setUpdatedTabIndexPipe(newTempTabIndexDevices);
                }
            }
        }

        if (multiplePipe.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multiplePipe];

                const deviceToUpdate = multiplePipe.find(
                    (element, index) => index === clickedDeviceIndex
                );

                deviceToUpdate.bgColor = textBgColor;
                deviceToUpdate.textColor = widgetTextColor;

                setMultiplePipe(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Clock") {
        if (Object.keys(tempTabIndexClock).length > 0) {
            const particularDevice = tempTabIndexClock[activeTabIndex];
            if (particularDevice !== undefined) {

                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        fontSize: textFontSize,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexClock[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        fontSize: textFontSize
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };

                    setTempTabIndexClock(newTempTabIndexDevices);
                    setUpdatedTabIndexClock(newTempTabIndexDevices);
                }
            }
        }

        if (multipleClock.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleClock];
                const deviceToUpdate = multipleClock.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.fontSize = textFontSize;

                setMultipleClock(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "DigitalIO") {
        if (Object.keys(tempTabIndexIO).length > 0) {
            const particularDevice = tempTabIndexIO[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        fontSize: textFontSize,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexIO[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        fontSize: textFontSize
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexIO(newTempTabIndexDevices);
                    setUpdatedTabIndexIO(newTempTabIndexDevices);
                }
            }
        }

        if (multipleIO.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleIO];
                const deviceToUpdate = multipleIO.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.fontSize = textFontSize;
                setMultipleIO(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Gauge") {
        if (Object.keys(tempTabIndexGauge).length > 0) {
            const particularDevice = tempTabIndexGauge[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        fontSize: textFontSize,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexGauge[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        fontSize: textFontSize
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexGauge(newTempTabIndexDevices);
                    setUpdatedTabIndexGauge(newTempTabIndexDevices);
                }
            }
        }

        if (multipleGauge.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleGauge];
                const deviceToUpdate = multipleGauge.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.fontSize = textFontSize;
                console.log("updatedDeviceName:", updatedDeviceName);


                setMultipleGauge(updatedDeviceName);
            }
        }

    }


    if (currentDevice === "ProgressBar") {
        if (Object.keys(tempTabIndexProgress).length > 0) {
            const particularDevice = tempTabIndexProgress[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        fontSize: textFontSize,
                        bgColor: textBgColor,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexProgress[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        fontSize: textFontSize,
                        bgColor: textBgColor,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexProgress(newTempTabIndexDevices);
                    setUpdatedTabIndexProgress(newTempTabIndexDevices);
                }
            }
        }

        if (multipleProgress.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleProgress];
                const deviceToUpdate = multipleProgress.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.fontSize = textFontSize;
                deviceToUpdate.bgColor = textBgColor;


                setMultipleProgress(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Line") {
        if (Object.keys(tempTabIndexLines).length > 0) {
            const particularDevice = tempTabIndexLines[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: textBgColor,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexLines[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: textBgColor,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexLines(newTempTabIndexDevices);
                    setUpdatedTabIndexLines(newTempTabIndexDevices);
                }
            }
        }

        if (multipleLines.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleLines];
                const deviceToUpdate = multipleLines.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;
                setMultipleLines(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Switch") {
        if (Object.keys(tempTabIndexSwitch).length > 0) {
            const particularDevice = tempTabIndexSwitch[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: textBgColor,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexSwitch[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: textBgColor,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexSwitch(newTempTabIndexDevices);
                    setUpdatedTabIndexSwitch(newTempTabIndexDevices);
                }
            }
        }

        if (multipleSwitch.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleSwitch];
                const deviceToUpdate = multipleSwitch.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;
                setMultipleSwitch(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Slider") {
        if (Object.keys(tempTabIndexSlider).length > 0) {
            const particularDevice = tempTabIndexSlider[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        bgColor: textBgColor,
                        fontSize : textFontSize,
                        textColor : widgetTextColor
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexSlider[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        bgColor: textBgColor,
                        fontSize : textFontSize,
                        textColor : widgetTextColor
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexSlider(newTempTabIndexDevices);
                    setUpdatedTabIndexSlider(newTempTabIndexDevices);
                }
            }
        }

        if (multipleSlider.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleSlider];
                const deviceToUpdate = multipleSlider.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.bgColor = textBgColor;
                deviceToUpdate.fontSize = textFontSize;
                deviceToUpdate.textColor = widgetTextColor
                
                setMultipleSlider(updatedDeviceName);
            }
        }

    }


    setIsBgColor(false);
}



export const handleIOText = ({
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    onText,
    offText,
    setIsChangeText,
    tempTabIndexIO,
    setTempTabIndexIO,
    setUpdatedTabIndexIO,
    multipleIO,
    setMultipleIO,
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    multipleSquare,
    setMultipleSquare,
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,

}) => {

    if (currentDevice === "DigitalIO") {
        if (Object.keys(tempTabIndexIO).length > 0) {
            const particularDevice = tempTabIndexIO[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        onText: onText,
                        offText: offText,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexIO[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        onText: onText,
                        offText: offText,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexIO(newTempTabIndexDevices);
                    setUpdatedTabIndexIO(newTempTabIndexDevices);
                }
            }
        }

        if (multipleIO.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleIO];
                const deviceToUpdate = multipleIO.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.onText = onText;
                deviceToUpdate.offText = offText;
                console
                    .log("updatedDeviceName:", updatedDeviceName);
                setMultipleIO(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Square") {
        if (Object.keys(tempTabIndexSquare).length > 0) {
            const particularDevice = tempTabIndexSquare[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        onText: onText,
                        offText: offText,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexSquare[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        onText: onText,
                        offText: offText,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexSquare(newTempTabIndexDevices);
                    setUpdatedTabIndexSquare(newTempTabIndexDevices);
                }
            }
        }

        if (multipleSquare.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleSquare];
                const deviceToUpdate = multipleSquare.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.onText = onText;
                deviceToUpdate.offText = offText;
                setMultipleSquare(updatedDeviceName);
            }
        }

    }


    if (currentDevice === "Circle") {
        if (Object.keys(tempTabIndexCircle).length > 0) {
            const particularDevice = tempTabIndexCircle[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        onText: onText,
                        offText: offText,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexCircle[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        onText: onText,
                        offText: offText,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexCircle(newTempTabIndexDevices);
                    setUpdatedTabIndexCircle(newTempTabIndexDevices);
                }
            }
        }

        if (multipleCircle.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleCircle];
                const deviceToUpdate = multipleCircle.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.onText = onText;
                deviceToUpdate.offText = offText;
                setMultipleCircle(updatedDeviceName);
            }
        }

    }

    setIsChangeText(false);

}



export const handleIOColor = ({
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    onColor,
    offColor,
    setIsChangeColor,
    setUpdatedTabIndexIO,
    setTempTabIndexIO,
    multipleIO,
    setMultipleIO,
    tempTabIndexIO,
    setUpdatedTabIndexSquare,
    setTempTabIndexSquare,
    multipleSquare,
    setMultipleSquare,
    tempTabIndexSquare,
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,


}) => {

    if (currentDevice === "DigitalIO") {
        if (Object.keys(tempTabIndexIO).length > 0) {
            const particularDevice = tempTabIndexIO[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        onColor: onColor,
                        offColor: offColor,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexIO[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        onColor: onColor,
                        offColor: offColor,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexIO(newTempTabIndexDevices);
                    setUpdatedTabIndexIO(newTempTabIndexDevices);
                }
            }
        }

        if (multipleIO.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleIO];
                const deviceToUpdate = multipleIO.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.onColor = onColor;
                deviceToUpdate.offColor = offColor;
                console
                    .log("updatedDeviceName:", updatedDeviceName);
                setMultipleIO(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Square") {
        if (Object.keys(tempTabIndexSquare).length > 0) {
            const particularDevice = tempTabIndexSquare[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        onColor: onColor,
                        offColor: offColor,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexSquare[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        onColor: onColor,
                        offColor: offColor,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexSquare(newTempTabIndexDevices);
                    setUpdatedTabIndexSquare(newTempTabIndexDevices);
                }
            }
        }

        if (multipleSquare.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleSquare];
                const deviceToUpdate = multipleSquare.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.onColor = onColor;
                deviceToUpdate.offColor = offColor;

                setMultipleSquare(updatedDeviceName);
            }
        }

    }

    if (currentDevice === "Circle") {
        if (Object.keys(tempTabIndexCircle).length > 0) {
            const particularDevice = tempTabIndexCircle[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];


                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],
                        onColor: onColor,
                        offColor: offColor,
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexCircle[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        onColor: onColor,
                        offColor: offColor,
                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexCircle(newTempTabIndexDevices);
                    setUpdatedTabIndexCircle(newTempTabIndexDevices);
                }
            }
        }

        if (multipleCircle.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleCircle];
                const deviceToUpdate = multipleCircle.find(
                    (element, index) => index === clickedDeviceIndex
                );
                deviceToUpdate.onColor = onColor;
                deviceToUpdate.offColor = offColor
                setMultipleCircle(updatedDeviceName);
            }
        }

    }

    setIsChangeColor(false);

}



// export const handleHideWidget = ({
//     currentDevice,
//     activeTabIndex,
//     tempImages,
//     selectedDevice,
//     clickedDeviceIndex,
//     setTempImages,
//     setUpdatedImages,
//     hideChannel,
//     hideValue,
//     tempTabIndexSquare,
//     setTempTabIndexSquare,
//     setUpdatedTabIndexSquare,
//     multipleSquare,
//     setMultipleSquare,
//     setIsHidePopup
// }) => {
//     if (currentDevice === "Square") {
//         if (Object.keys(tempTabIndexSquare).length > 0) {
//             const particularDevice = tempTabIndexSquare[activeTabIndex];
//             if (particularDevice !== undefined) {
//                 const originalDeviceIndex = tempImages.findIndex(
//                     (data) => data.id === selectedDevice.id
//                 );
//                 if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
//                     // storing new channel name to send data in widget
//                     let temporaryWidgets = [...tempImages];


//                     const updatedData = {
//                         ...temporaryWidgets[originalDeviceIndex],
//                         hideChannel: hideChannel,
//                         hideValue: hideValue,
//                     };

//                     temporaryWidgets[originalDeviceIndex] = updatedData;

//                     setTempImages(temporaryWidgets);
//                     setUpdatedImages(temporaryWidgets);

//                     // storing new channel name to display data in main page

//                     let oldtabIndexTable = [...tempTabIndexSquare[activeTabIndex]];

//                     const organizedDeviceIndex = oldtabIndexTable.findIndex(
//                         (data) => data.id === selectedDevice.id
//                     );

//                     const newUpdatedData = {
//                         ...oldtabIndexTable[organizedDeviceIndex],
//                         hideChannel: hideChannel,
//                         hideValue: hideValue,
//                     };

//                     oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

//                     const newTempTabIndexDevices = {
//                         [activeTabIndex]: oldtabIndexTable,
//                     };



//                     setTempTabIndexSquare(newTempTabIndexDevices);
//                     setUpdatedTabIndexSquare(newTempTabIndexDevices);
//                 }
//             }
//         }

//         if (multipleSquare.length > 1) {
//             if (!selectedDevice?.id) {

//                 const updatedDeviceName = [...multipleSquare];
//                 const deviceToUpdate = multipleSquare.find(
//                     (element, index) => index === clickedDeviceIndex
//                 );
//                 deviceToUpdate.hideChannel = hideChannel;
//                 deviceToUpdate.hideValue = hideValue;

//                 setMultipleSquare(updatedDeviceName);
//             }
//         }

//     }

//     setIsHidePopup(false);
// }


export const handleHideWidget = ({
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    hideChannel,
    hideValue,

    // Square
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    multipleSquare,
    setMultipleSquare,

    // CIrcle
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,

    //Line
    tempTabIndexLines,
    setTempTabIndexLines,
    setUpdatedTabIndexLines,
    multipleLines,
    setMultipleLines,

    //Images

    setMultipleImages,
    multipleImages,
    setUpdatedTabIndexImages,
    setTempTabIndexImages,
    tempTabIndexImages,

    setMultipleDisplay,
    multipleDisplay,
    setUpdatedTabIndexDisplay,
    setTempTabIndexDisplay,
    tempTabIndexDisplay,

    setMultipleIO,
    multipleIO,
    setUpdatedTabIndexIO,
    setTempTabIndexIO,
    tempTabIndexIO,

    setMultipleMotor,
    multipleMotor,
    setUpdatedTabIndexMotor,
    setTempTabIndexMotor,
    tempTabIndexMotor,

    setMultiplePolygone,
    multiplePolygone,
    setUpdatedTabIndexPolygone,
    setTempTabIndexPolygone,
    tempTabIndexPolygone,

    setMultiplePipe,
    multiplePipe,
    setUpdatedTabIndexPipe,
    setTempTabIndexPipe,
    tempTabIndexPipe,

    setMultipleSwitch,
    multipleSwitch,
    setUpdatedTabIndexSwitch,
    setTempTabIndexSwitch,
    tempTabIndexSwitch,

    setMultipleCheckbox,
    multipleCheckbox,
    setUpdatedTabIndexCheckbox,
    setTempTabIndexCheckbox,
    tempTabIndexCheckbox,

    setMultipleRadio,
    multipleRadio,
    setUpdatedTabIndexRadio,
    setTempTabIndexRadio,
    tempTabIndexRadio,

    setMultipleSlider,
    multipleSlider,
    setUpdatedTabIndexSlider,
    setTempTabIndexSlider,
    tempTabIndexSlider,

    setMultipleLamp,
    multipleLamp,
    setUpdatedTabIndexLamp,
    setTempTabIndexLamp,
    tempTabIndexLamp,

    setMultiplePush,
    multiplePush,
    setUpdatedTabIndexPush,
    setTempTabIndexPush,
    tempTabIndexPush,

    setMultipleLink,
    multipleLink,
    setUpdatedTabIndexLink,
    setTempTabIndexLink,
    tempTabIndexLink,

    setMultipleClock,
    multipleClock,
    setUpdatedTabIndexClock,
    setTempTabIndexClock,
    tempTabIndexClock,

    setMultipleText,
    multipleText,
    setUpdatedTabIndexText,
    setTempTabIndexText,
    tempTabIndexText,




    setIsHidePopup
}) => {

    // 🔹 Map widget → states (NO extra logic)
    let tempTabIndex,
        setTempTabIndex,
        setUpdatedTabIndex,
        multipleWidget,
        setMultipleWidget;

    if (currentDevice === "Square") {
        tempTabIndex = tempTabIndexSquare;
        setTempTabIndex = setTempTabIndexSquare;
        setUpdatedTabIndex = setUpdatedTabIndexSquare;
        multipleWidget = multipleSquare;
        setMultipleWidget = setMultipleSquare;
    }

    if (currentDevice === "Circle") {
        tempTabIndex = tempTabIndexCircle;
        setTempTabIndex = setTempTabIndexCircle;
        setUpdatedTabIndex = setUpdatedTabIndexCircle;
        multipleWidget = multipleCircle;
        setMultipleWidget = setMultipleCircle;
    }

    if (currentDevice === "Line") {
        tempTabIndex = tempTabIndexLines;
        setTempTabIndex = setTempTabIndexLines;
        setUpdatedTabIndex = setUpdatedTabIndexLines;
        multipleWidget = multipleLines;
        setMultipleWidget = setMultipleLines;
    }

    if (currentDevice === "Image") {
        tempTabIndex = tempTabIndexImages;
        setTempTabIndex = setTempTabIndexImages;
        setUpdatedTabIndex = setUpdatedTabIndexImages;
        multipleWidget = multipleImages;
        setMultipleWidget = setMultipleImages;
    }

    if (currentDevice === "Display") {
        tempTabIndex = tempTabIndexDisplay;
        setTempTabIndex = setTempTabIndexDisplay;
        setUpdatedTabIndex = setUpdatedTabIndexDisplay;
        multipleWidget = multipleDisplay;
        setMultipleWidget = setMultipleDisplay;
    }

    if (currentDevice === "DigitalIO") {
        tempTabIndex = tempTabIndexIO;
        setTempTabIndex = setTempTabIndexIO;
        setUpdatedTabIndex = setUpdatedTabIndexIO;
        multipleWidget = multipleIO;
        setMultipleWidget = setMultipleIO;

    }

    if (currentDevice === "Motor") {
        tempTabIndex = tempTabIndexMotor;
        setTempTabIndex = setTempTabIndexMotor;
        setUpdatedTabIndex = setUpdatedTabIndexMotor;
        multipleWidget = multipleMotor;
        setMultipleWidget = setMultipleMotor;
    }

    if (currentDevice === "Polygone") {

        tempTabIndex = tempTabIndexPolygone;
        setTempTabIndex = setTempTabIndexPolygone;
        setUpdatedTabIndex = setUpdatedTabIndexPolygone;
        multipleWidget = multiplePolygone;
        setMultipleWidget = setMultiplePolygone;
    }

    if (currentDevice === "Pipe") {

        tempTabIndex = tempTabIndexPipe;
        setTempTabIndex = setTempTabIndexPipe;
        setUpdatedTabIndex = setUpdatedTabIndexPipe;
        multipleWidget = multiplePipe;
        setMultipleWidget = setMultiplePipe;
    }

    if (currentDevice === "Switch") {
        tempTabIndex = tempTabIndexSwitch;
        setTempTabIndex = setTempTabIndexSwitch;
        setUpdatedTabIndex = setUpdatedTabIndexSwitch;
        multipleWidget = multipleSwitch;
        setMultipleWidget = setMultipleSwitch;
    }

    if (currentDevice === "Checkbox") {
        tempTabIndex = tempTabIndexCheckbox;
        setTempTabIndex = setTempTabIndexCheckbox;
        setUpdatedTabIndex = setUpdatedTabIndexCheckbox;
        multipleWidget = multipleCheckbox;
        setMultipleWidget = setMultipleCheckbox;
    }

    if (currentDevice === "Radio") {
        tempTabIndex = tempTabIndexRadio;
        setTempTabIndex = setTempTabIndexRadio;
        setUpdatedTabIndex = setUpdatedTabIndexRadio;
        multipleWidget = multipleRadio;
        setMultipleWidget = setMultipleRadio;
    }

    if (currentDevice === "Slider") {
        tempTabIndex = tempTabIndexSlider;
        setTempTabIndex = setTempTabIndexSlider;
        setUpdatedTabIndex = setUpdatedTabIndexSlider;
        multipleWidget = multipleSlider;
        setMultipleWidget = setMultipleSlider;
    }

    if (currentDevice === "Lamp") {
        tempTabIndex = tempTabIndexLamp;
        setTempTabIndex = setTempTabIndexLamp;
        setUpdatedTabIndex = setUpdatedTabIndexLamp;
        multipleWidget = multipleLamp;
        setMultipleWidget = setMultipleLamp;
    }

    if (currentDevice === "Push") {
        tempTabIndex = tempTabIndexPush;
        setTempTabIndex = setTempTabIndexPush;
        setUpdatedTabIndex = setUpdatedTabIndexPush;
        multipleWidget = multiplePush;
        setMultipleWidget = setMultiplePush;
    }

    if (currentDevice === "Link") {
        tempTabIndex = tempTabIndexLink;
        setTempTabIndex = setTempTabIndexLink;
        setUpdatedTabIndex = setUpdatedTabIndexLink;
        multipleWidget = multipleLink;
        setMultipleWidget = setMultipleLink;
    }


    if (currentDevice === "Clock") {
        tempTabIndex = tempTabIndexClock;
        setTempTabIndex = setTempTabIndexClock;
        setUpdatedTabIndex = setUpdatedTabIndexClock;
        multipleWidget = multipleClock;
        setMultipleWidget = setMultipleClock;
    }

    if (currentDevice === "Text") {
        tempTabIndex = tempTabIndexText;
        setTempTabIndex = setTempTabIndexText;
        setUpdatedTabIndex = setUpdatedTabIndexText;
        multipleWidget = multipleText;
        setMultipleWidget = setMultipleText;
    }

    // if (!tempTabIndex) {
    //     setIsHidePopup(false);
    //     // return;
    // }


    /* ================== COMMON LOGIC ================== */
    if (tempTabIndex) {

        if (Object.keys(tempTabIndex).length > 0) {
            const particularDevice = tempTabIndex[activeTabIndex];

            if (particularDevice && selectedDevice?.id) {

                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {

                    const updatedImages = [...tempImages];
                    updatedImages[originalDeviceIndex] = {
                        ...updatedImages[originalDeviceIndex],
                        hideChannel,
                        hideValue,
                    };

                    setTempImages(updatedImages);
                    setUpdatedImages(updatedImages);

                    const updatedTabDevices = [...particularDevice];
                    const organizedIndex = updatedTabDevices.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    updatedTabDevices[organizedIndex] = {
                        ...updatedTabDevices[organizedIndex],
                        hideChannel,
                        hideValue,
                    };
                    const newTabState = {
                        [activeTabIndex]: updatedTabDevices,
                    };

                    setTempTabIndex(newTabState);
                    setUpdatedTabIndex(newTabState);
                }
            }
        }
    }


    if (multipleWidget?.length > 1 && !selectedDevice?.id) {
        const updatedMultiple = [...multipleWidget];
        updatedMultiple[clickedDeviceIndex] = {
            ...updatedMultiple[clickedDeviceIndex],
            hideChannel,
            hideValue,
        };

        setMultipleWidget(updatedMultiple);
    }

    setIsHidePopup(false);
};



export const handleHorizontalMovementValues = ({
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,

    // Square
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    multipleSquare,
    setMultipleSquare,

    // Circle
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,

    //Image 

    setMultipleImages,
    multipleImages,
    setUpdatedTabIndexImages,
    setTempTabIndexImages,
    tempTabIndexImages,

    //Lines
    tempTabIndexLines,
    setTempTabIndexLines,
    setUpdatedTabIndexLines,
    multipleLines,
    setMultipleLines,

    setIsHorizontalMove,
    conditionValue,
    moveValue,
    horizontalMoveChannel
}) => {

    const newConditionValue = {
        toLeft: conditionValue?.toLeft,
        toRight: conditionValue?.toRight,
        toTop: conditionValue?.toTop,
        toBottom: conditionValue?.toBottom
    };

    const newMoveValue = {
        toLeft: moveValue?.toLeft,
        toRight: moveValue?.toRight,
        toTop: moveValue?.toTop,
        toBottom: moveValue?.toBottom
    };

    /* ================== WIDGET STATE MAPPING ================== */

    let tempTabIndex,
        setTempTabIndex,
        setUpdatedTabIndex,
        multipleWidget,
        setMultipleWidget;

    if (currentDevice === "Square") {
        tempTabIndex = tempTabIndexSquare;
        setTempTabIndex = setTempTabIndexSquare;
        setUpdatedTabIndex = setUpdatedTabIndexSquare;
        multipleWidget = multipleSquare;
        setMultipleWidget = setMultipleSquare;
    }

    if (currentDevice === "Circle") {
        tempTabIndex = tempTabIndexCircle;
        setTempTabIndex = setTempTabIndexCircle;
        setUpdatedTabIndex = setUpdatedTabIndexCircle;
        multipleWidget = multipleCircle;
        setMultipleWidget = setMultipleCircle;
    }

    if (currentDevice === "Image") {
        tempTabIndex = tempTabIndexImages;
        setTempTabIndex = setTempTabIndexImages;
        setUpdatedTabIndex = setUpdatedTabIndexImages;
        multipleWidget = multipleImages;
        setMultipleWidget = setMultipleImages;
    }

    if (currentDevice === "Line") {
        tempTabIndex = tempTabIndexLines;
        setTempTabIndex = setTempTabIndexLines;
        setUpdatedTabIndex = setUpdatedTabIndexLines;
        multipleWidget = multipleLines;
        setMultipleWidget = setMultipleLines;
    }


    // if (!tempTabIndex) {
    //     setIsHorizontalMove(false);
    // }

    /* ================== COMMON LOGIC ================== */
    if (tempTabIndex) {

        if (Object.keys(tempTabIndex).length > 0) {
            const particularDevice = tempTabIndex[activeTabIndex];

            if (particularDevice && selectedDevice?.id) {

                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {

                    const updatedImages = [...tempImages];
                    updatedImages[originalDeviceIndex] = {
                        ...updatedImages[originalDeviceIndex],
                        conditionValue: newConditionValue,
                        moveValue: newMoveValue,
                        horizontalMoveChannel
                    };

                    setTempImages(updatedImages);
                    setUpdatedImages(updatedImages);

                    const updatedTabDevices = [...particularDevice];
                    const organizedIndex = updatedTabDevices.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    updatedTabDevices[organizedIndex] = {
                        ...updatedTabDevices[organizedIndex],
                        conditionValue: newConditionValue,
                        moveValue: newMoveValue,
                        horizontalMoveChannel
                    };

                    const newTabState = {
                        [activeTabIndex]: updatedTabDevices
                    };

                    setTempTabIndex(newTabState);
                    setUpdatedTabIndex(newTabState);
                }
            }
        }
    }

    console.log("multipleWidget:", multipleWidget);
    console.log("selectedDevice:", selectedDevice);

    /* ================== MULTIPLE WIDGET CASE ================== */

    if (multipleWidget?.length > 1 && !selectedDevice?.id) {
        const updatedMultiple = [...multipleWidget];

        updatedMultiple[clickedDeviceIndex] = {
            ...updatedMultiple[clickedDeviceIndex],
            conditionValue: newConditionValue,
            moveValue: newMoveValue,
            horizontalMoveChannel
        };
        console.log("updatedMultiple for multiple widget:", updatedMultiple);
        setMultipleWidget(updatedMultiple);
    }

    setIsHorizontalMove(false);
};



export const handleVerticalMovementValues = ({
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,

    // Square
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    multipleSquare,
    setMultipleSquare,

    // Future widgets
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,

    //Image

    setMultipleImages,
    multipleImages,
    setUpdatedTabIndexImages,
    setTempTabIndexImages,
    tempTabIndexImages,

    tempTabIndexLines,
    setTempTabIndexLines,
    setUpdatedTabIndexLines,
    multipleLines,
    setMultipleLines,

    setIsVerticalMove,
    conditionValue,
    moveValue,
    verticalMoveChannel
}) => {

    const newConditionValue = {
        toLeft: conditionValue?.toLeft,
        toRight: conditionValue?.toRight,
        toTop: conditionValue?.toTop,
        toBottom: conditionValue?.toBottom
    };

    const newMoveValue = {
        toLeft: moveValue?.toLeft,
        toRight: moveValue?.toRight,
        toTop: moveValue?.toTop,
        toBottom: moveValue?.toBottom
    };

    /* ================== WIDGET STATE MAPPING ================== */

    let tempTabIndex,
        setTempTabIndex,
        setUpdatedTabIndex,
        multipleWidget,
        setMultipleWidget;

    if (currentDevice === "Square") {
        tempTabIndex = tempTabIndexSquare;
        setTempTabIndex = setTempTabIndexSquare;
        setUpdatedTabIndex = setUpdatedTabIndexSquare;
        multipleWidget = multipleSquare;
        setMultipleWidget = setMultipleSquare;
    }

    if (currentDevice === "Circle") {
        tempTabIndex = tempTabIndexCircle;
        setTempTabIndex = setTempTabIndexCircle;
        setUpdatedTabIndex = setUpdatedTabIndexCircle;
        multipleWidget = multipleCircle;
        setMultipleWidget = setMultipleCircle;
    }

    if (currentDevice === "Image") {
        tempTabIndex = tempTabIndexImages;
        setTempTabIndex = setTempTabIndexImages;
        setUpdatedTabIndex = setUpdatedTabIndexImages;
        multipleWidget = multipleImages;
        setMultipleWidget = setMultipleImages;
    }

    if (currentDevice === "Line") {
        tempTabIndex = tempTabIndexLines;
        setTempTabIndex = setTempTabIndexLines;
        setUpdatedTabIndex = setUpdatedTabIndexLines;
        multipleWidget = multipleLines;
        setMultipleWidget = setMultipleLines;
    }

    //  No widget → exit

    /* ================== COMMON LOGIC ================== */
    if (tempTabIndex) {

        if (Object.keys(tempTabIndex).length > 0) {
            const particularDevice = tempTabIndex[activeTabIndex];

            if (particularDevice && selectedDevice?.id) {

                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {

                    const updatedImages = [...tempImages];

                    updatedImages[originalDeviceIndex] = {
                        ...updatedImages[originalDeviceIndex],
                        conditionValue: newConditionValue,
                        moveValue: newMoveValue,
                        verticalMoveChannel
                    };

                    setTempImages(updatedImages);
                    setUpdatedImages(updatedImages);

                    const updatedTabDevices = [...particularDevice];
                    const organizedIndex = updatedTabDevices.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    updatedTabDevices[organizedIndex] = {
                        ...updatedTabDevices[organizedIndex],
                        conditionValue: newConditionValue,
                        moveValue: newMoveValue,
                        verticalMoveChannel
                    };

                    const newTabState = {
                        [activeTabIndex]: updatedTabDevices
                    };

                    setTempTabIndex(newTabState);
                    setUpdatedTabIndex(newTabState);
                }
            }
        }
    }



    /* ================== MULTIPLE WIDGET CASE ================== */

    if (multipleWidget?.length > 1 && !selectedDevice?.id) {
        const updatedMultiple = [...multipleWidget];

        updatedMultiple[clickedDeviceIndex] = {
            ...updatedMultiple[clickedDeviceIndex],
            conditionValue: newConditionValue,
            moveValue: newMoveValue,
            verticalMoveChannel
        };

        setMultipleWidget(updatedMultiple);
    }

    setIsVerticalMove(false);
};




export const handleLineStyle = ({
    tempTabIndexLineChart,
    setTempTabIndexLineChart,
    multipleLineCharts,
    setMultipleLineCharts,
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    lineStyle,
    isCurveLine,
    isSteppedLine,
    setTempImages,
    setUpdatedImages,
    setUpdatedTabIndexLineChart,
    setIsLineStyle
}) => {

    if (currentDevice === "LineChart") {



        if (Object.keys(tempTabIndexLineChart).length > 0) {
            const particularDevice = tempTabIndexLineChart[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];



                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],

                        lineStyle: lineStyle,
                        isCurveLine: isCurveLine,
                        isSteppedLine: isSteppedLine
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexLineChart[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        lineStyle: lineStyle,
                        isCurveLine: isCurveLine,
                        isSteppedLine: isSteppedLine

                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexLineChart(newTempTabIndexDevices);
                    setUpdatedTabIndexLineChart(newTempTabIndexDevices);
                }
            }
        }

        if (multipleLineCharts.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleLineCharts];
                const deviceToUpdate = multipleLineCharts.find(
                    (element, index) => index === clickedDeviceIndex
                );

                deviceToUpdate.lineStyle = lineStyle;
                deviceToUpdate.isCurveLine = isCurveLine;
                deviceToUpdate.isSteppedLine = isSteppedLine;


                setMultipleLineCharts(updatedDeviceName);
            }
        }

    }

    setIsLineStyle(false);


};



export const handleYRange = ({
    tempTabIndexLineChart,
    setTempTabIndexLineChart,
    multipleLineCharts,
    setMultipleLineCharts,
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    setUpdatedTabIndexLineChart,
    setIsYRange,
    yRange
}) => {

    if (currentDevice === "LineChart") {

        if (Object.keys(tempTabIndexLineChart).length > 0) {
            const particularDevice = tempTabIndexLineChart[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];



                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],

                        minY: yRange?.min,
                        maxY: yRange?.max
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexLineChart[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        minY: yRange?.min,
                        maxY: yRange?.max

                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexLineChart(newTempTabIndexDevices);
                    setUpdatedTabIndexLineChart(newTempTabIndexDevices);
                }
            }
        }

        if (multipleLineCharts.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleLineCharts];
                const deviceToUpdate = multipleLineCharts.find(
                    (element, index) => index === clickedDeviceIndex
                );

                deviceToUpdate.minY = yRange?.min;
                deviceToUpdate.maxY = yRange?.max;


                setMultipleLineCharts(updatedDeviceName);
            }
        }

    }

    setIsYRange(false);


}

export const handleGraphInterval = ({
    tempTabIndexLineChart,
    setTempTabIndexLineChart,
    multipleLineCharts,
    setMultipleLineCharts,
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    setUpdatedTabIndexLineChart,
    setIsGraphInterval,
    xInterval,
    yInterval
}) => {

    if (currentDevice === "LineChart") {

        if (Object.keys(tempTabIndexLineChart).length > 0) {
            const particularDevice = tempTabIndexLineChart[activeTabIndex];
            if (particularDevice !== undefined) {
                const originalDeviceIndex = tempImages.findIndex(
                    (data) => data.id === selectedDevice.id
                );
                if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {
                    // storing new channel name to send data in widget
                    let temporaryWidgets = [...tempImages];



                    const updatedData = {
                        ...temporaryWidgets[originalDeviceIndex],

                        xInterval: xInterval,
                        yInterval: yInterval
                    };

                    temporaryWidgets[originalDeviceIndex] = updatedData;

                    setTempImages(temporaryWidgets);
                    setUpdatedImages(temporaryWidgets);

                    // storing new channel name to display data in main page

                    let oldtabIndexTable = [...tempTabIndexLineChart[activeTabIndex]];

                    const organizedDeviceIndex = oldtabIndexTable.findIndex(
                        (data) => data.id === selectedDevice.id
                    );

                    const newUpdatedData = {
                        ...oldtabIndexTable[organizedDeviceIndex],
                        xInterval: xInterval,
                        yInterval: yInterval

                    };

                    oldtabIndexTable[organizedDeviceIndex] = newUpdatedData;

                    const newTempTabIndexDevices = {
                        [activeTabIndex]: oldtabIndexTable,
                    };



                    setTempTabIndexLineChart(newTempTabIndexDevices);
                    setUpdatedTabIndexLineChart(newTempTabIndexDevices);
                }
            }
        }

        if (multipleLineCharts.length > 1) {
            if (!selectedDevice?.id) {

                const updatedDeviceName = [...multipleLineCharts];
                const deviceToUpdate = multipleLineCharts.find(
                    (element, index) => index === clickedDeviceIndex
                );

                deviceToUpdate.xInterval = xInterval;
                deviceToUpdate.yInterval = yInterval;


                setMultipleLineCharts(updatedDeviceName);
            }
        }

    }

    setIsGraphInterval(false);


}

export const handleBlink = ({
    currentDevice,
    activeTabIndex,
    tempImages,
    selectedDevice,
    clickedDeviceIndex,
    setTempImages,
    setUpdatedImages,
    blinkChannel,
    blinkValue,
    blinkFunction,
    blinkFrequency,

    // Square
    tempTabIndexSquare,
    setTempTabIndexSquare,
    setUpdatedTabIndexSquare,
    multipleSquare,
    setMultipleSquare,

    // CIrcle
    tempTabIndexCircle,
    setTempTabIndexCircle,
    setUpdatedTabIndexCircle,
    multipleCircle,
    setMultipleCircle,

    //Line
    multipleLines,
    setMultipleLines,
    tempTabIndexLines,
    setTempTabIndexLines,
    setUpdatedTabIndexLines,

    //Images

    multipleImages,
    tempTabIndexImages,
    setTempTabIndexImages,
    setUpdatedTabIndexImages,
    setMultipleImages,

    //IO
    multipleIO,
    tempTabIndexIO,
    setTempTabIndexIO,
    setUpdatedTabIndexIO,
    setMultipleIO,

    setIsBlinkPopup
}) => {

    // 🔹 Map widget → states (NO extra logic)
    let tempTabIndex,
        setTempTabIndex,
        setUpdatedTabIndex,
        multipleWidget,
        setMultipleWidget;

    if (currentDevice === "Square") {
        tempTabIndex = tempTabIndexSquare;
        setTempTabIndex = setTempTabIndexSquare;
        setUpdatedTabIndex = setUpdatedTabIndexSquare;
        multipleWidget = multipleSquare;
        setMultipleWidget = setMultipleSquare;
    }

    if (currentDevice === "Circle") {
        tempTabIndex = tempTabIndexCircle;
        setTempTabIndex = setTempTabIndexCircle;
        setUpdatedTabIndex = setUpdatedTabIndexCircle;
        multipleWidget = multipleCircle;
        setMultipleWidget = setMultipleCircle;
    }


    if (currentDevice === "Line") {
        tempTabIndex = tempTabIndexLines;
        setTempTabIndex = setTempTabIndexLines;
        setUpdatedTabIndex = setUpdatedTabIndexLines;
        multipleWidget = multipleLines;
        setMultipleWidget = setMultipleLines;
    }

    if (currentDevice === "Image") {
        tempTabIndex = tempTabIndexImages;
        setTempTabIndex = setTempTabIndexImages;
        setUpdatedTabIndex = setUpdatedTabIndexImages;
        multipleWidget = multipleImages;
        setMultipleWidget = setMultipleImages;
    }

    if (currentDevice === "DigitalIO") {
        tempTabIndex = tempTabIndexIO;
        setTempTabIndex = setTempTabIndexIO;
        setUpdatedTabIndex = setUpdatedTabIndexIO;
        multipleWidget = multipleIO;
        setMultipleWidget = setMultipleIO;
    }



    if (!tempTabIndex) {
        setIsBlinkPopup(false);
        return;
    }


    /* ================== COMMON LOGIC ================== */

    if (Object.keys(tempTabIndex).length > 0) {
        const particularDevice = tempTabIndex[activeTabIndex];

        if (particularDevice && selectedDevice?.id) {

            const originalDeviceIndex = tempImages.findIndex(
                (data) => data.id === selectedDevice.id
            );

            if (particularDevice[clickedDeviceIndex]?.id === selectedDevice.id) {

                const updatedImages = [...tempImages];

                updatedImages[originalDeviceIndex] = {
                    ...updatedImages[originalDeviceIndex],
                    blinkChannel,
                    blinkValue,
                    blinkFunction,
                    blinkFrequency
                };

                setTempImages(updatedImages);
                setUpdatedImages(updatedImages);

                const updatedTabDevices = [...particularDevice];
                const organizedIndex = updatedTabDevices.findIndex(
                    (data) => data.id === selectedDevice.id
                );

                updatedTabDevices[organizedIndex] = {
                    ...updatedTabDevices[organizedIndex],
                    blinkChannel,
                    blinkFunction,
                    blinkFrequency,
                    blinkValue
                };

                const newTabState = {
                    [activeTabIndex]: updatedTabDevices,
                };

                setTempTabIndex(newTabState);
                setUpdatedTabIndex(newTabState);
            }
        }
    }


    if (multipleWidget?.length > 1 && !selectedDevice?.id) {
        const updatedMultiple = [...multipleWidget];
        updatedMultiple[clickedDeviceIndex] = {
            ...updatedMultiple[clickedDeviceIndex],
            blinkChannel,
            blinkFunction,
            blinkFrequency,
            blinkValue,
        };
        setMultipleWidget(updatedMultiple);
    }

    setIsBlinkPopup(false);
};
